// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_CatList = require("../Data.CatList/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_NonEmpty = require("../Data.List.NonEmpty/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Partial_Unsafe = require("../Partial.Unsafe/index.js");
var Emit = (function () {
    function Emit(value0) {
        this.value0 = value0;
    };
    Emit.create = function (value0) {
        return new Emit(value0);
    };
    return Emit;
})();
var Visit = (function () {
    function Visit(value0) {
        this.value0 = value0;
    };
    Visit.create = function (value0) {
        return new Visit(value0);
    };
    return Visit;
})();
var Graph = function (x) {
    return x;
};
var vertices = function (v) {
    return Data_Functor.map(Data_List_Types.functorList)(Data_Tuple.fst)(Data_Map_Internal.values(v));
};
var unfoldGraph = function (dictOrd) {
    return function (dictFunctor) {
        return function (dictFoldable) {
            return function (dictFoldable1) {
                return function (ks) {
                    return function (label) {
                        return function (edges$prime) {
                            return Data_Map_Internal.fromFoldable(dictOrd)(dictFoldable)(Data_Functor.map(dictFunctor)(function (k) {
                                return new Data_Tuple.Tuple(k, new Data_Tuple.Tuple(label(k), Data_Set.fromFoldable(dictFoldable1)(dictOrd)(edges$prime(k))));
                            })(ks));
                        };
                    };
                };
            };
        };
    };
};
var toMap = function (v) {
    return v;
};
var parents = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Map.keys(Data_Map_Internal.filter(dictOrd)((function () {
                var $175 = Data_Foldable.elem(Data_Set.foldableSet)(dictOrd.Eq0())(k);
                return function ($176) {
                    return $175(Data_Tuple.snd($176));
                };
            })())(v));
        };
    };
};
var outEdges = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.snd)(Data_Map_Internal.lookup(dictOrd)(k)(v));
        };
    };
};
var lookup = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.fst)(Data_Map_Internal.lookup(dictOrd)(k)(v));
        };
    };
};
var isParentOf = function (dictOrd) {
    return function (g) {
        return function (k1) {
            return function (k2) {
                return Data_Set.member(dictOrd)(k1)(parents(dictOrd)(k2)(g));
            };
        };
    };
};
var isValidPath = function (dictOrd) {
    return function (g) {
        return function (v) {
            return Data_Tuple.fst(Data_Foldable.foldl(Data_List_Types.foldableList)(function (v1) {
                return function (c) {
                    return new Data_Tuple.Tuple(isParentOf(dictOrd)(g)(v1.value1)(c), c);
                };
            })(new Data_Tuple.Tuple(true, v.value0))(v.value1));
        };
    };
};
var insertVertex = function (dictOrd) {
    return function (k) {
        return function (v) {
            return function (v1) {
                return Graph(Data_Map_Internal.insertWith(dictOrd)(function (v3) {
                    return function (v4) {
                        return new Data_Tuple.Tuple(v, v3.value1);
                    };
                })(k)(new Data_Tuple.Tuple(v, Data_Monoid.mempty(Data_Set.monoidSet(dictOrd))))(v1));
            };
        };
    };
};
var insertEdge = function (dictOrd) {
    return function (from) {
        return function (to) {
            return function (v) {
                var keys = Data_Map.keys(v);
                var $102 = Data_Set.member(dictOrd)(from)(keys) && Data_Set.member(dictOrd)(to)(keys);
                if ($102) {
                    return Data_Maybe.Just.create(Graph(Data_Map_Internal.alter(dictOrd)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Bifunctor.rmap(Data_Tuple.bifunctorTuple)(Data_Set.insert(dictOrd)(to))))(from)(v)));
                };
                return Data_Maybe.Nothing.value;
            };
        };
    };
};
var insertEdgeWithVertices = function (dictOrd) {
    return function (v) {
        return function (v1) {
            return function (g) {
                return Partial_Unsafe.unsafePartialBecause("Just inserted vertices")(function (dictPartial) {
                    return Data_Maybe.fromJust()(insertEdge(dictOrd)(v.value0)(v1.value0)(Data_Tuple.uncurry(insertVertex(dictOrd))(v)(Data_Tuple.uncurry(insertVertex(dictOrd))(v1)(g))));
                });
            };
        };
    };
};
var functorGraph = new Data_Functor.Functor(function (f) {
    return function (v) {
        return Data_Functor.map(Data_Map_Internal.functorMap)(Data_Bifunctor.lmap(Data_Tuple.bifunctorTuple)(f))(v);
    };
});
var fromMap = Graph;
var eqSortStep = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Emit && y instanceof Emit) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            if (x instanceof Visit && y instanceof Visit) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            return false;
        };
    });
};
var ordSortStep = function (dictOrd) {
    return new Data_Ord.Ord(function () {
        return eqSortStep(dictOrd.Eq0());
    }, function (x) {
        return function (y) {
            if (x instanceof Emit && y instanceof Emit) {
                return Data_Ord.compare(dictOrd)(x.value0)(y.value0);
            };
            if (x instanceof Emit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Emit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Visit && y instanceof Visit) {
                return Data_Ord.compare(dictOrd)(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Data.Graph (line 310, column 1 - line 310, column 57): " + [ x.constructor.name, y.constructor.name ]);
        };
    });
};
var topologicalSort = function (dictOrd) {
    return function (v) {
        var visit = function ($copy_state) {
            return function ($copy_stack) {
                var $tco_var_state = $copy_state;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(state, stack) {
                    var v1 = Data_CatList.uncons(stack);
                    if (v1 instanceof Data_Maybe.Nothing) {
                        $tco_done = true;
                        return state;
                    };
                    if (v1 instanceof Data_Maybe.Just && v1.value0.value0 instanceof Emit) {
                        var state$prime = {
                            result: new Data_List_Types.Cons(v1.value0.value0.value0, state.result),
                            unvisited: state.unvisited
                        };
                        $tco_var_state = state$prime;
                        $copy_stack = v1.value0.value1;
                        return;
                    };
                    if (v1 instanceof Data_Maybe.Just && v1.value0.value0 instanceof Visit) {
                        if (Data_Map_Internal.member(dictOrd)(v1.value0.value0.value0)(state.unvisited)) {
                            var start = {
                                result: state.result,
                                unvisited: Data_Map_Internal["delete"](dictOrd)(v1.value0.value0.value0)(state.unvisited)
                            };
                            var next = Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))(Data_Tuple.snd)(Data_Map_Internal.lookup(dictOrd)(v1.value0.value0.value0)(v));
                            $tco_var_state = start;
                            $copy_stack = Data_Semigroup.append(Data_CatList.semigroupCatList)(Data_CatList.fromFoldable(Data_Set.foldableSet)(Data_Set.map(ordSortStep(dictOrd))(Visit.create)(next)))(Data_CatList.cons(new Emit(v1.value0.value0.value0))(v1.value0.value1));
                            return;
                        };
                        if (Data_Boolean.otherwise) {
                            $tco_var_state = state;
                            $copy_stack = v1.value0.value1;
                            return;
                        };
                    };
                    throw new Error("Failed pattern match at Data.Graph (line 327, column 7 - line 345, column 40): " + [ v1.constructor.name ]);
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($tco_var_state, $copy_stack);
                };
                return $tco_result;
            };
        };
        var initialState = {
            unvisited: v,
            result: Data_List_Types.Nil.value
        };
        var go = function ($copy_v1) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v1) {
                var v2 = Data_Map_Internal.findMin(v1.unvisited);
                if (v2 instanceof Data_Maybe.Just) {
                    $copy_v1 = visit(v1)(Data_CatList.fromFoldable(Data_Foldable.foldableArray)([ new Visit(v2.value0.key) ]));
                    return;
                };
                if (v2 instanceof Data_Maybe.Nothing) {
                    $tco_done = true;
                    return v1.result;
                };
                throw new Error("Failed pattern match at Data.Graph (line 321, column 7 - line 323, column 26): " + [ v2.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($copy_v1);
            };
            return $tco_result;
        };
        return go(initialState);
    };
};
var empty = Data_Map_Internal.empty;
var edges = function (dictOrd) {
    return function (v) {
        return Data_Set.fromFoldable(Data_List_Types.foldableList)(Data_Tuple.ordTuple(dictOrd)(dictOrd))(Control_Bind.bindFlipped(Data_List_Types.bindList)(function (v1) {
            return Data_Functor.map(Data_List_Types.functorList)(Data_Tuple.Tuple.create(v1.value0))(Data_List.fromFoldable(Data_Set.foldableSet)(Data_Tuple.snd(v1.value1)));
        })(Data_Map_Internal.toUnfoldable(Data_List_Types.unfoldableList)(v)));
    };
};
var deleteVertex = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Graph(Data_Map_Internal["delete"](dictOrd)(k)(v));
        };
    };
};
var deleteEdge = function (dictOrd) {
    return function (from) {
        return function (to) {
            return function (v) {
                return Graph(Data_Map_Internal.alter(dictOrd)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Bifunctor.rmap(Data_Tuple.bifunctorTuple)(Data_Set["delete"](dictOrd)(to))))(from)(v));
            };
        };
    };
};
var children = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))((function () {
                var $177 = Data_Set.fromFoldable(Data_Set.foldableSet)(dictOrd);
                return function ($178) {
                    return $177(Data_Tuple.snd($178));
                };
            })())(Data_Map_Internal.lookup(dictOrd)(k)(v));
        };
    };
};
var descendants = function (dictOrd) {
    return function (k$prime) {
        return function (g) {
            var go = function (k) {
                var dd = children(dictOrd)(k)(g);
                return Data_Set.unions(Data_Set.foldableSet)(dictOrd)(Data_Set.insert(Data_Set.ordSet(dictOrd))(dd)(Data_Set.map(Data_Set.ordSet(dictOrd))(go)(dd)));
            };
            return go(k$prime);
        };
    };
};
var isDescendantOf = function (dictOrd) {
    return function (g) {
        return function (k1) {
            return function (k2) {
                return Data_Set.member(dictOrd)(k1)(descendants(dictOrd)(k2)(g));
            };
        };
    };
};
var isChildOf = function (dictOrd) {
    return function (g) {
        return function (k1) {
            return function (k2) {
                return Data_Set.member(dictOrd)(k1)(children(dictOrd)(k2)(g));
            };
        };
    };
};
var isInCycle = function (dictOrd) {
    return function (k$prime) {
        return function (g) {
            var go = function (seen) {
                return function (k) {
                    var dd = children(dictOrd)(k)(g);
                    var v = new Data_Tuple.Tuple(Data_Eq.eq(Data_Set.eqSet(dictOrd.Eq0()))(dd)(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd))), Data_Set.member(dictOrd)(k)(seen));
                    if (v.value0) {
                        return false;
                    };
                    if (v.value1) {
                        return Data_Eq.eq(dictOrd.Eq0())(k)(k$prime);
                    };
                    if (!v.value0 && !v.value1) {
                        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(go(Data_Set.insert(dictOrd)(k)(seen)))(dd);
                    };
                    throw new Error("Failed pattern match at Data.Graph (line 264, column 7 - line 267, column 70): " + [ v.constructor.name ]);
                };
            };
            return go(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))(k$prime);
        };
    };
};
var isCyclic = function (dictOrd) {
    return function (g) {
        var keys = function (v) {
            return Data_Map.keys(v);
        };
        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Function.flip(isInCycle(dictOrd))(g))(keys(g));
    };
};
var isAcyclic = function (dictOrd) {
    var $179 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
    var $180 = isCyclic(dictOrd);
    return function ($181) {
        return $179($180($181));
    };
};
var ancestors = function (dictOrd) {
    return function (k$prime) {
        return function (g) {
            var go = function (k) {
                var da = parents(dictOrd)(k)(g);
                return Data_Set.unions(Data_Set.foldableSet)(dictOrd)(Data_Set.insert(Data_Set.ordSet(dictOrd))(da)(Data_Set.map(Data_Set.ordSet(dictOrd))(go)(da)));
            };
            return go(k$prime);
        };
    };
};
var isAncestorOf = function (dictOrd) {
    return function (g) {
        return function (k1) {
            return function (k2) {
                return Data_Set.member(dictOrd)(k1)(ancestors(dictOrd)(k2)(g));
            };
        };
    };
};
var alterVertex = function (dictOrd) {
    return function (f) {
        return function (k) {
            return function (v) {
                var applyF = function (v1) {
                    return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(f(new Data_Maybe.Just(v1.value0)));
                };
                return Graph(Data_Map_Internal.alter(dictOrd)(function (v1) {
                    return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(applyF)(v1);
                })(k)(v));
            };
        };
    };
};
var alterEdges = function (dictOrd) {
    return function (f) {
        return function (k) {
            return function (v) {
                var applyF = function (v1) {
                    return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create(v1.value0))(f(new Data_Maybe.Just(v1.value1)));
                };
                return Graph(Data_Map_Internal.alter(dictOrd)(function (v1) {
                    return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(applyF)(v1);
                })(k)(v));
            };
        };
    };
};
var allPaths = function (dictOrd) {
    return function (start) {
        return function (end) {
            return function (g) {
                var go = function (hist) {
                    return function (k) {
                        var hist$prime = Data_Maybe.maybe(Control_Applicative.pure(Data_List_Types.applicativeNonEmptyList)(k))(Data_List_Types.nelCons(k))(hist);
                        var children$prime = children(dictOrd)(k)(g);
                        var $173 = Data_Eq.eq(dictOrd.Eq0())(end)(k);
                        if ($173) {
                            return Data_Set.singleton(hist$prime);
                        };
                        var $174 = Data_Eq.eq(Data_Set.eqSet(dictOrd.Eq0()))(children$prime)(Data_Set.empty);
                        if ($174) {
                            return Data_Set.empty;
                        };
                        return Data_Foldable.foldMap(Data_Set.foldableSet)(Data_Set.monoidSet(Data_List_Types.ordNonEmptyList(dictOrd)))(go(new Data_Maybe.Just(hist$prime)))(children$prime);
                    };
                };
                return Data_Set.map(Data_List_Types.ordNonEmptyList(dictOrd))(Data_List_NonEmpty.reverse)(go(Data_Maybe.Nothing.value)(start));
            };
        };
    };
};
var shortestPath = function (dictOrd) {
    return function (start) {
        return function (end) {
            return function (g) {
                var asInt = Control_Category.identity(Control_Category.categoryFn);
                return Data_Array.head(Data_Array.sortWith(Data_Ord.ordInt)((function () {
                    var $182 = Data_Foldable.length(Data_List_Types.foldableNonEmptyList)(Data_Semiring.semiringInt);
                    return function ($183) {
                        return asInt($182($183));
                    };
                })())(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(allPaths(dictOrd)(start)(end)(g))));
            };
        };
    };
};
var areConnected = function (dictOrd) {
    return function (g) {
        return function (start) {
            return function (end) {
                return Data_Maybe.isJust(shortestPath(dictOrd)(start)(end)(g));
            };
        };
    };
};
var adjacent = function (dictOrd) {
    return function (k) {
        return function (g) {
            return Data_Set.union(dictOrd)(children(dictOrd)(k)(g))(parents(dictOrd)(k)(g));
        };
    };
};
var areAdjacent = function (dictOrd) {
    return function (g) {
        return function (k1) {
            return function (k2) {
                return Data_Set.member(dictOrd)(k1)(adjacent(dictOrd)(k2)(g));
            };
        };
    };
};
module.exports = {
    unfoldGraph: unfoldGraph,
    fromMap: fromMap,
    toMap: toMap,
    empty: empty,
    insertEdge: insertEdge,
    deleteEdge: deleteEdge,
    insertVertex: insertVertex,
    deleteVertex: deleteVertex,
    insertEdgeWithVertices: insertEdgeWithVertices,
    vertices: vertices,
    edges: edges,
    lookup: lookup,
    outEdges: outEdges,
    children: children,
    isChildOf: isChildOf,
    descendants: descendants,
    isDescendantOf: isDescendantOf,
    parents: parents,
    isParentOf: isParentOf,
    ancestors: ancestors,
    isAncestorOf: isAncestorOf,
    topologicalSort: topologicalSort,
    isInCycle: isInCycle,
    isCyclic: isCyclic,
    isAcyclic: isAcyclic,
    alterVertex: alterVertex,
    alterEdges: alterEdges,
    adjacent: adjacent,
    areAdjacent: areAdjacent,
    areConnected: areConnected,
    isValidPath: isValidPath,
    shortestPath: shortestPath,
    allPaths: allPaths,
    functorGraph: functorGraph
};
